#import "~/graphql/fragments/socialFragment.graphql"
#import "~/graphql/fragments/assets/defaultImageAsset.graphql"

fragment flexiblePostCardsByTags on flexibleSections_postCardsByTags_BlockType {
    __typename
    tags {
        id
    }
}
